/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'freight': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" d="M12.796 31.265l17.732-11.416v11.416h2.946V19.849L51.21 31.265h5.087l-21.143-13.61c1.433-.904 2.372-2.408 2.372-4.109 0-2.294-1.72-4.232-4.05-4.819V6.225h2.708v-2.67h-8.361v2.67h2.705v2.502c-2.327.587-4.047 2.525-4.047 4.819 0 1.7.94 3.204 2.364 4.108L7.706 31.265h5.09zm19.206-20.054c1.419 0 2.576 1.048 2.576 2.335 0 1.291-1.157 2.34-2.576 2.34-1.422 0-2.575-1.049-2.575-2.34 0-1.287 1.153-2.335 2.575-2.335zM56.867 33.269H7.135l-3.58 3.249v20.675l3.58 3.251h49.732l3.578-3.25V36.517l-3.578-3.25zm-44.131 23.44h-2.363V37.004h2.363V56.71zm8.173 0h-2.354V37.004h2.354V56.71zm8.182 0h-2.358V37.004h2.358V56.71zm8.18 0h-2.358V37.004h2.359V56.71zm8.18 0h-2.36V37.004h2.36V56.71zm8.178 0h-2.36V37.004h2.36V56.71z" _fill="#EF7812"/>'
  }
})
